import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Box,
  Text,
  Heading,
  FormControl,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import { updateFormConfig } from "../../../../redux/actions/formConfigActions";
const Footer = ({ dispatchUpdateFormConfig, styleClasses }) => {
  const styleClassesValue = styleClasses.length ? styleClasses.join(" ") : "";
  const handleOnChange = (e) => {
    const styleClasses = e.target.value.split(" ");
    dispatchUpdateFormConfig({ type: "styleClass", styleClasses });
  };
  return (
    <Box w="600" h="145px">
      <Heading
        mb="8px"
        fontSize="16px"
        fontWeight="600"
        color="#12344D"
        w="161px"
        h="24px"
      >
        Customize form style
      </Heading>
      <Text fontSize="14px" fontWeight="400" color="#475867" w="551px" h="40px">
        Customize the style of the form by entering CSS class names for the form
        wrapper. Multiple class names should be seperated with spaces.
      </Text>
      <FormControl w="600px" h="57px" mt="16px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Form CSS class{" "}
        </FormLabel>
        <Input
          onChange={handleOnChange}
          w="598px"
          h="32px"
          border="1px solid #CFD7DF"
          borderRadius="4px"
          type="text"
          value={styleClassesValue}
          placeholder="Enter CSS class name"
        ></Input>
      </FormControl>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    styleClasses: state.formConfig.styleClasses,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchUpdateFormConfig: bindActionCreators(updateFormConfig, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
